import { useAlert } from '~/@ui/alert/useAlert'
import { useAuthStore } from '~/@utils/api/authStore'
import { getApi } from '~/@utils/api/getApi'
import { getErrorMessage } from '~/@utils/api/getErrorMessage'

export const useLoggedInUser = () => {
  const { showAlert } = useAlert()
  const { authToken, removeAuthToken } = useAuthStore()

  const hasAuthToken = () => {
    return authToken
  }

  const checkLoggedInUser = async () => {
    try {
      const { data: response } =
        await getApi().userAuthAppApiControllerGetCurrentUserInfo()

      if ('success' in response) {
        return response
      }

      throw new Error('Nastala neznáma chyba pri načítavaní užívateľa.')
    } catch (err) {
      removeAuthToken()
      console.error(err)
      showAlert('error', getErrorMessage(err))
    }
  }

  const clearLoggedInUser = () => {
    removeAuthToken()
  }

  return {
    hasAuthToken,
    checkLoggedInUser,
    clearLoggedInUser,
  }
}
